import { render } from "./CourseInsight.vue?vue&type=template&id=10b83513&scoped=true"
import script from "./CourseInsight.vue?vue&type=script&lang=js"
export * from "./CourseInsight.vue?vue&type=script&lang=js"

import "./CourseInsight.vue?vue&type=style&index=0&id=10b83513&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b83513"]])

export default __exports__